import React from "react";
import { facilities } from "../mock";
import { MapPin } from "lucide-react";
import useReveal from "../hooks/useReveal";

/**
 * Full-bleed factory band: one large photograph doing the talking, a single
 * statement, and the three plants as a photo strip — imagery instead of cards.
 */
export default function FactoryBand() {
  const [ref, inView] = useReveal();
  const hero = facilities[0];

  return (
    <section
      className="kse-band relative text-white"
      style={{ backgroundImage: `url(${hero?.image})` }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#0d1640]/90 via-[#0d1640]/60 to-[#0d1640]/30" />
      <div className="relative kse-container py-28 lg:py-40">
        <p className="kse-eyebrow kse-eyebrow--light">On the floor</p>
        <h2 className="kse-h2 kse-h2--light max-w-3xl">
          500 hands. 15 lines. One standard, from the first sample to the last carton.
        </h2>
        <p className="text-blue-100/80 text-lg max-w-xl mt-6">
          Every order is planned, cut, sewn, finished and documented in-house &mdash; which is how we keep
          delivery dates that brands build their launches around.
        </p>
      </div>

      <div ref={ref} className="relative kse-container pb-10">
        <div className="grid grid-cols-3 gap-3 sm:gap-4">
          {facilities.map((f, i) => (
            <figure
              key={f.name}
              className={`group relative rounded-2xl overflow-hidden h-32 sm:h-44 lg:h-52 reveal ${inView ? "in-view" : ""}`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <img src={f.image} alt={f.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d1640]/90 to-transparent" />
              <figcaption className="absolute bottom-3 left-3 right-3">
                <span className="flex items-center gap-1.5 text-white font-bold text-xs sm:text-sm">
                  <MapPin size={13} className="shrink-0" /> {f.name}
                </span>
                {f.city && <span className="block text-blue-100/70 text-[11px] sm:text-xs mt-0.5">{f.city}</span>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
